import { gql } from "@apollo/client/core";

export const GET_EVENTS = gql`
  query GetEvents {
    events {
      id
      groupName
      groupType
      organizerName
      organizerEmail
      origin
      destination
      airline
      departDate
      returnDate
      passengers
      status
      invitees {
        id
        status
      }
    }
  }
`;

export const GET_EVENT_DETAILS = gql`
  query GetEventDetails($eventId: ID!) {
    eventDetails(eventId: $eventId) {
      event {
        id
        groupName
        groupType
        organizerName
        organizerEmail
        destination
        departDate
        returnDate
        passengers
      }
      metrics {
        bookedCount
        paymentModel
      }
    }
    passengerManifest(eventId: $eventId) {
      id
      name
      number
      airline
      locator
      ticket
      amountPaid
    }
    agreement(eventId: $eventId) {
      fileName
      uploadedAt
      status
    }
  }
`;

export const GET_SYSTEM_HEALTH = gql`
  query GetSystemHealth {
    systemHealth {
      metrics {
        id
        label
        value
        target
        status
        helper
        detailA
        detailAValue
        detailB
        detailBValue
      }
      alerts {
        id
        severity
        message
        service
        status
        occurredAt
      }
    }
  }
`;

export const GET_PRODUCT_SETUP = gql`
  query GetProductSetup {
    productSetup {
      leadProduct
      products {
        id
        category
        label
        description
        enabled
        premium
      }
    }
  }
`;

export const GET_ORGANIZERS = gql`
  query GetOrganizers {
    organizers {
      id
      name
      email
      events
      travelers
      bookingRate
      lifetimeBookings
      engagement
      programs {
        id
        eventId
        name
        endsOn
      }
    }
  }
`;

export const TOGGLE_PRODUCT_FEATURE = gql`
  mutation ToggleProductFeature($featureId: ID!, $enabled: Boolean!) {
    toggleProductFeature(featureId: $featureId, enabled: $enabled) {
      leadProduct
    }
  }
`;

export const SET_LEAD_PRODUCT = gql`
  mutation SetLeadProduct($featureId: ID!) {
    setLeadProduct(featureId: $featureId) {
      leadProduct
    }
  }
`;

export const GET_CLIENTS = gql`
  query GetClients {
    clients {
      id
      name
      slug
      tier
      status
      events
      organizers
      travelers
      lastActivity
    }
  }
`;

export const ADD_PASSENGER = gql`
  mutation AddPassenger(
    $eventId: ID!
    $name: String!
    $airline: String!
    $locator: String!
    $ticket: String!
    $amountPaid: String!
  ) {
    addPassenger(
      eventId: $eventId
      name: $name
      airline: $airline
      locator: $locator
      ticket: $ticket
      amountPaid: $amountPaid
    ) {
      id
    }
  }
`;

export const EDIT_GROUP = gql`
  mutation EditGroup(
    $eventId: ID!
    $groupName: String
    $groupType: String
    $destination: String
    $organizerName: String
    $organizerEmail: String
    $departDate: String
    $returnDate: String
    $passengers: Int
    $paymentModel: String
  ) {
    editGroup(
      eventId: $eventId
      groupName: $groupName
      groupType: $groupType
      destination: $destination
      organizerName: $organizerName
      organizerEmail: $organizerEmail
      departDate: $departDate
      returnDate: $returnDate
      passengers: $passengers
      paymentModel: $paymentModel
    ) {
      id
    }
  }
`;

export const GET_EVENT = gql`
  query GetEvent($eventId: ID!) {
    event(eventId: $eventId) {
      id
      groupName
      groupType
      organizerName
      organizerEmail
      destination
      departDate
      returnDate
      passengers
      description
      status
    }
    eventInvitees(eventId: $eventId) {
      id
      name
      email
      status
      recentActivity
    }
    eventSchedule(eventId: $eventId) {
      id
      title
      dayLabel
      timeRange
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation UpdateEvent(
    $eventId: ID!
    $groupName: String
    $description: String
    $destination: String
    $venueName: String
    $venueAddress: String
  ) {
    updateEvent(
      eventId: $eventId
      groupName: $groupName
      description: $description
      destination: $destination
      venueName: $venueName
      venueAddress: $venueAddress
    ) {
      id
      groupName
      description
      destination
    }
  }
`;

export const ADD_INVITEES = gql`
  mutation AddInvitees($eventId: ID!, $invitees: [InviteeInput!]!) {
    addInvitees(eventId: $eventId, invitees: $invitees) {
      id
      name
      email
      status
      recentActivity
    }
  }
`;

export const ADD_SCHEDULE_ITEM = gql`
  mutation AddScheduleItem(
    $eventId: ID!
    $dayLabel: String!
    $timeRange: String!
    $title: String!
    $description: String
  ) {
    addScheduleItem(
      eventId: $eventId
      dayLabel: $dayLabel
      timeRange: $timeRange
      title: $title
      description: $description
    ) {
      id
      title
      dayLabel
      timeRange
    }
  }
`;

export const REMIND_INVITEE = gql`
  mutation RemindInvitee($eventId: ID!, $inviteeId: ID!) {
    remindInvitee(eventId: $eventId, inviteeId: $inviteeId) {
      id
      name
      email
      status
      recentActivity
    }
  }
`;

export const CREATE_EVENT = gql`
  mutation CreateEvent(
    $groupName: String!
    $groupType: String!
    $organizerName: String!
    $organizerEmail: String!
    $destination: String!
    $departDate: String!
    $returnDate: String!
    $passengers: Int!
    $origin: String
    $venueName: String
    $venueAddress: String
  ) {
    createEvent(
      groupName: $groupName
      groupType: $groupType
      organizerName: $organizerName
      organizerEmail: $organizerEmail
      destination: $destination
      departDate: $departDate
      returnDate: $returnDate
      passengers: $passengers
      origin: $origin
      venueName: $venueName
      venueAddress: $venueAddress
    ) {
      id
      groupName
      groupType
      destination
      departDate
      returnDate
      passengers
      status
    }
  }
`;
